__turbopack_context__.v({
  "footerLink": "FooterLink-module__oalHTq__footerLink",
});
